import { render } from "./CarouselMobile.vue?vue&type=template&id=52b616ca"
import script from "./CarouselMobile.vue?vue&type=script&lang=js"
export * from "./CarouselMobile.vue?vue&type=script&lang=js"

import exportComponent from "C:\\development\\ON\\montalvo.ti\\dish-frontend-web-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__